import { isRouteErrorResponse, useRouteError } from "react-router-dom";
import Alert from "@mui/material/Alert";
import Error404 from "pages/maintenance/404";
import Error401 from "pages/maintenance/401";
import Error503 from "pages/maintenance/503";
import Error500 from "pages/maintenance/500";
import UnderConstruction from "pages/maintenance/under-construction";

export default function ErrorBoundary() {
  const error = useRouteError();

  if (isRouteErrorResponse(error)) {
    if (error.status === 404) {
      return <Error404 />;
    }

    if (error.status === 401) {
      return <Error401 />;
    }

    if (error.status === 503) {
      return <Error503 />;
    }

    if (error.status === 418) {
      return <Alert color="error">Error 418 - Contact administrator</Alert>;
    }

    if (error.status === 500) {
      return <Error500 />;
    }
  }
  return <UnderConstruction />;
}